import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardBody } from './PageChrome';
import {
  buildOrderWhatsAppMessage,
  getSavedDeliveryPartnerPhone,
  openWhatsAppWithMessage,
  saveDeliveryPartnerPhone,
} from '../lib/whatsappShare';

/**
 * Share order + map link with a delivery partner via wa.me (free — admin taps Send in WhatsApp).
 */
export function ShareOrderWhatsApp({ order }) {
  const [partnerPhone, setPartnerPhone] = useState('');
  const [rememberPhone, setRememberPhone] = useState(true);
  const [shareError, setShareError] = useState('');

  useEffect(() => {
    setPartnerPhone(getSavedDeliveryPartnerPhone());
  }, []);

  const messagePreview = useMemo(() => buildOrderWhatsAppMessage(order), [order]);

  function handleShare(e) {
    e.preventDefault();
    setShareError('');
    const trimmed = partnerPhone.trim();
    if (rememberPhone && trimmed) saveDeliveryPartnerPhone(trimmed);
    const result = openWhatsAppWithMessage(trimmed, messagePreview);
    if (!result.ok) setShareError(result.error);
  }

  return (
    <Card className="mb-3 border-success border-opacity-25">
      <CardBody className="p-3 p-md-4">
        <h2 className="h6 text-secondary text-uppercase letter-spacing-tight mb-2">Share with delivery partner</h2>
        <p className="small text-secondary mb-3">
          Opens WhatsApp with this order ready to send — no API cost. Enter the rider&apos;s number, review the message,
          then tap Send in WhatsApp.
        </p>
        <form onSubmit={handleShare} className="share-whatsapp-form">
          <div className="mb-2">
            <label htmlFor="delivery-partner-wa" className="form-label small text-secondary mb-1">
              Partner WhatsApp number
            </label>
            <input
              id="delivery-partner-wa"
              type="tel"
              inputMode="tel"
              autoComplete="tel"
              className="form-control form-control-sm"
              placeholder="e.g. 9876543210"
              value={partnerPhone}
              onChange={(ev) => setPartnerPhone(ev.target.value)}
            />
          </div>
          <div className="form-check mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="remember-partner-wa"
              checked={rememberPhone}
              onChange={(ev) => setRememberPhone(ev.target.checked)}
            />
            <label className="form-check-label small text-secondary" htmlFor="remember-partner-wa">
              Remember this number
            </label>
          </div>
          {shareError ? (
            <div className="alert alert-danger py-2 small mb-2" role="alert">
              {shareError}
            </div>
          ) : null}
          <button type="submit" className="btn btn-success btn-sm w-100">
            Open in WhatsApp
          </button>
        </form>
        <details className="mt-3 small">
          <summary className="text-secondary" style={{ cursor: 'pointer' }}>
            Preview message
          </summary>
          <pre className="bg-light border rounded p-2 mt-2 mb-0 small text-break" style={{ maxHeight: '12rem', overflow: 'auto', whiteSpace: 'pre-wrap' }}>
            {messagePreview || '—'}
          </pre>
        </details>
      </CardBody>
    </Card>
  );
}
